export default {
    LOAD_LIST_TIPO_FAIXA(state, data) {
        state.listTipoFaixa = data
    },
    PREPARE_TO_EDIT_TIPO_FAIXA(state, data) {
        state.tipoFaixa = data
    },
    RESET_TIPO_FAIXA(state) {
        state.tipoFaixa = {
            id: null,
            nome: '',
            contaPadrao: null,
            tipoPagRecPadrao: null,
            ativo: true,
            lancaMensalidade: false,
            regraPrimeiraMensalidade: 'INTEGRAL',
            lancarNoTitular: false,
            consolidarNoTitular: false
        }
    },
}
